import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getPlanTypeFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.plan_type}`, { params: req });
    return response;
}


export const postPlanTypeFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.plan_type}`, reqBody);
    return response;
}

export const patchPlanTypeFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.plan_type}`, reqBody);
    return response;
}

export const deletePlanTypeFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.plan_type}`, { data: reqBody });
    return response;
}


// Plan Module api services


export const getPlanModuleFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.module_api}`, { params: req });
    return response;
}


export const postPlanModuleFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.module_api}`, reqBody);
    return response;
}

export const patchPlanModuleFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.module_api}`, reqBody);
    return response;
}

export const deletePlanModuleFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.module_api}`, { data: reqBody });
    return response;
}


// plan

export const getPlanFn = (req) => {
    const response = protectedApi.get(`${ENDPOINTS.plan}`, { params: req });
    return response;
}


export const postPlanFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.plan}`, reqBody);
    return response;
}

export const patchPlanFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.plan}`, reqBody);
    return response;
}

export const deletePlanFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.plan}`, { data: reqBody });
    return response;
}



